/** FRU-24790: a typed home value short enough to be shorthand reads as thousands ("300" is $300,000, "1500" is $1.5M). Before this,
 *  any typed number under 60,000 put the slider on its bottom stop, so "300" for $300K was saved as $60,000. A full number, and a
 *  number too small to be shorthand, is left as typed. */
export function homeValueFromTyped(typed: number): number {
  return typedHomeValueIsThousands(typed) ? typed * 1000 : typed;
}

/** Whether a typed number is read as thousands by homeValueFromTyped (the field shows a "K" suffix while it is). */
export function typedHomeValueIsThousands(typed: number): boolean {
  return isFinite(typed) && typed >= 30 && typed < 10000;
}

/** Whether a typed number is far enough along to move the slider: an empty box or a number under 30 is still being typed. */
export function typedHomeValueIsReady(typed: number): boolean {
  return isFinite(typed) && typed >= 30;
}
